const colors = {
  color: "#707070",
  bg: "#FFFFFF",
  primaryColorScheme: "gray",
  primary: "#3FA7B6",
  secondary: "#FDBC31",
  gradientTop: "#FFFFFF",
  gradientBottom: "#FFFFFF",
  headingColor: "black",
  cardBg: "#FFFFFF",
  cardLink: "#000000",
  cardLinkHover: "#2B6CB0",
  black: "#201D1D",
  // dark: {
  //   color: defaultColors.whiteAlpha["800"],
  //   bg: defaultColors.gray["900"],
  //   primary: defaultColors.blue["300"],
  //   gradientTop: defaultColors.gray["900"],
  //   gradientBottom: defaultColors.gray["700"],
  //   headingColor: "white",
  //   cardBg: defaultColors.gray["700"],
  //   cardLink: defaultColors.white,
  //   cardLinkHover: defaultColors.blue["400"],
  // },
}

export default colors
